<template lang="pug">
  .container
    h1.main_title Users Overview
    .col-md-12(v-if="dataLoading")
      .loader
    .col-md-12(v-else)
      .col-md-3
        h3 User type 
          //- small (
            span.online {{ total.online }}
            span /{{ total.device }})
        .filter_container
          checkbox(
            v-for="(index, type) in userType"
            v-bind:checked.sync="filterUserTypeValue[type.name]" 
            v-bind:value="type.name"
            type="info"
            name="userType"
            @click="filterChanged"
          )
            span.filter_option {{ type.name }}
              //- small
                em.filter_option (
                  span.online {{ type.onlineAmount }}
                  span /{{ type.amount }})
        h3 Status
        .filter_container
          checkbox(
            v-bind:checked.sync="filterUserStatusValue.online"
            value="online"
            type="info"
            @click="filterChanged"
          )
            //- span.glyphicon.glyphicon-record.filter_option_icon.text-success
            span.filter_option Online
              //- small
              //-   em.filter_option (
              //-     span.online {{ total.online }}
              //-     | )
          checkbox(
            v-bind:checked.sync="filterUserStatusValue.offline"
            value="offline"
            type="info"
            @click="filterChanged"
          )
            //- span.glyphicon.glyphicon-record.filter_option_icon.text-muted
            span.filter_option Offline
              //- small
              //-   em.filter_option (
              //-     span.offline {{ total.offline }}
              //-     | )
          checkbox(
            v-bind:checked.sync="filterUserStatusValue.virgin"
            value="virgin"
            type="info"
            @click="filterChanged"
          )
            //- span.glyphicon.glyphicon-record.filter_option_icon.text-danger
            span.filter_option No Records
              //- small
              //-   em.filter_option (
              //-     span.virgin {{ total.noRecord }}
              //-     | )
      .col-md-9
        pagination(
          v-if="outputData.length > 10"
          v-bind:target-ary.sync='outputData'
          v-bind:count-of-page.sync="countOfPage"
          v-bind:count-of-pagination="countOfPagination"
          v-bind:curr-page.sync="currentPage"
          v-bind:curr-pagination-sec.sync='currPaginationSec'
        )
        br(v-else)
        table.table.table-bordered.table-hover.log_table(v-if="outputData.length > 0")
          tr(v-for="(index, user) in outputData | limitBy countOfPage pageStart")
            td
              .media
                .media-left.media-top
                  .badge_container(v-if="user.installer")
                    .installer_badge
                  .media-object
                    img.img-rounded.user_photo(v-bind:src="user.photo !== null ? user.photo : '/static/svg/UnknownUser.svg'")
                .media-body
                  //- .media-heading
                  .user_title
                    b {{ user.name }}
                  span.pull-right.time(v-bind:class="user.status.connectType")
                    span.glyphicon(v-bind:class="user.status.class")
                    span.text-capitalize {{ user.status.info }}
                  div(style="display:flex;align-items:flex-end;justify-content:space-between;")
                    div
                      h5.text-info
                        span.glyphicon.glyphicon-envelope
                        | 
                        span {{ user.email }}
                      //- h5.text-info
                        span.glyphicon.glyphicon-globe
                        | 
                        span Taiwan, Taipei
                    .btn-group.btn-group-xs
                      button.btn.btn-default(
                        v-bind:disabled="true"
                        v-if="user.accessLog != null"
                        @click="showUserLocation(user)"
                      )
                        span.glyphicon.glyphicon-map-marker
                        span  Location 
                      button.btn.btn-default(
                        v-if="user.accessLog != null"
                        @click="showUserAccessLog(user['.key'])"
                      )
                        span.glyphicon.glyphicon-th-list
                        span  Activity 
                      button.btn.btn-default(
                        v-if="user.hasDevice"
                        @click="showUserDevices(user['.key'])"
                      )
                        span.glyphicon.glyphicon-hdd
                        span  Devices 
                        small.text-info(v-if="user.hasDevice") ({{ user.devices.length }})
                      //- button.btn.btn-default(v-if="!user.installer")
                      //-   span.glyphicon.glyphicon-star-empty
                      //-   span  Assign 
        h3.text-center(v-else) No data
  .container
    modal(
      v-bind:show.sync="modalStatus"
      v-bind:title="modalTitle"
      v-bind:large="modalSize.large"
      v-bind:small="modalSize.small"
    )
      .modal-body(slot="modal-body")
        div(v-if="modalPurpose === null") Hello world
        div(v-if="modalPurpose === 'location'")
          highmaps(
            v-if="ip2LocationLoaded"
            v-bind:options="mapOptions"
          )
          .loader(v-else)
        div(v-if="modalPurpose === 'userDeviceTable'")
          table.table.table-bordered.table-striped(v-if="modalOutputData.length > 0")
            thead
              th ID
              th Type
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'type' ? currentSortInASC ? 'glyphicon-sort-by-order' : 'glyphicon-sort-by-order-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('type')"
                  )
              th MAC
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'mac' ? currentSortInASC ? 'glyphicon-sort-by-alphabet' : 'glyphicon-sort-by-alphabet-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('mac')"
                  )
              th Status
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'isOnline' ? currentSortInASC ? 'glyphicon-sort-by-attributes' : 'glyphicon-sort-by-attributes-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('isOnline')"
                  )
            tbody
              tr(v-for="data in modalOutputData")
                td {{ $index + 1 }}
                td {{ data.type }}
                td {{ data['.key'] }}
                  small(v-if="data.nickname")  ({{ data.nickname }})
                td
                  span.badge.online(v-if="data.isOnline")  Online 
                  span.badge.offline(v-else)  Offline 
          h3.text-center(v-else) No data
        div(v-if="modalPurpose === 'userAccessLogTable'")
          table.table.table-bordered.table-striped(v-if="modalOutputData.length > 0")
            thead
              th ID
              th Date
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'time' ? currentSortInASC ? 'glyphicon-sort-by-order' : 'glyphicon-sort-by-order-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('time')"
                  )
              th Event
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'type' ? currentSortInASC ? 'glyphicon-sort-by-alphabet' : 'glyphicon-sort-by-alphabet-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('type')"
                  )
              th IP
                .pull-right
                  span.glyphicon(
                    v-bind:class="currentSortBy === 'ip' ? currentSortInASC ? 'glyphicon-sort-by-attributes' : 'glyphicon-sort-by-attributes-alt' : 'glyphicon-sort sort_default'"
                    @click="sortBy('ip')"
                  )
            tbody
              tr(v-for="userAccessLog in modalOutputData")
                td {{ $index + 1 }}
                td {{ userAccessLog.time | timeFormat 'YYYY/MM/DD hh:mm:ss A' }}
                td
                  span.badge.online(v-if="userAccessLog.type")  Online 
                  span.badge.offline(v-else)  Offline 
                td {{ userAccessLog.ip }}
          h3.text-center(v-else) No data
      .modal-footer.hide(slot="modal-footer")
</template>

<script>
  import { getDeviceRef, getDeviceOnlineRef, getUserRef } from 'src/index'
  import pagination from 'src/components/common/Pagination.vue'
  import { accordion, checkbox, modal, panel } from 'vue-strap'
  import Highcharts from 'highcharts'
  import World from 'static/map/world.geo.json'
  import _ from 'lodash'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    components: {
      accordion,
      checkbox,
      modal,
      pagination,
      panel
    },
    data () {
      return {
        /* default */
        userType: [
          {
            name: 'Installer',
            amount: 0,
            onlineAmount: 0,
            offlineAmount: 0,
            noRecordAmount: 0
          },
          {
            name: 'Client',
            amount: 0,
            onlineAmount: 0,
            offlineAmount: 0,
            noRecordAmount: 0
          }
        ],
        ipList: [],
        ipLocationData: [],
        outputData: [],
        /* chart options */
        mapOptions: {
          colors: ['rgba(19,64,117,0.05)', 'rgba(19,64,117,0.2)', 'rgba(19,64,117,0.4)', 'rgba(19,64,117,0.5)', 'rgba(19,64,117,0.6)', 'rgba(19,64,117,0.8)', 'rgba(19,64,117,1)'],
          title: {
            text: ''
          },

          mapNavigation: {
            enabled: true
          },

          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.city}</b><br>{point.date}'
          },

          series: [{
            mapData: World,
            name: 'Basemap',
            borderColor: '#A0A0A0',
            nullColor: 'rgba(200, 200, 200, 0.3)',
            showInLegend: false
          }]
        },
        /* data status */
        fbDeviceLoaded: false,
        fbDeviceOnlineLoaded: false,
        fbUserLoaded: false,
        ip2LocationLoaded: false,
        /* pagination */
        countOfPage: 10,
        countOfPagination: 5,
        currentPage: 1,
        currPaginationSec: 1,
        /* sort data */
        currentSortBy: null,
        currentSortInASC: null,
        currentSortCount: 0,
        /* filter */
        filterUserTypeValue: {},
        filterUserStatusValue: {},
        filterUserLocationValue: {},
        /* modal setting */
        modalStatus: false,
        modalPurpose: null,
        modalTitle: 'Hello',
        modalSize: {
          large: false,
          small: false
        },
        modalData: []
      }
    },
    firebase () {
      return {
        fbDevice: {
          source: getDeviceRef(),
          readyCallback: () => {
            this.fbDeviceLoaded = true
          }
        },
        fbDeviceOnline: {
          source: getDeviceOnlineRef(),
          asObject: true,
          readyCallback: () => {
            this.fbDeviceOnlineLoaded = true
          }
        },
        fbUser: {
          source: getUserRef(),
          readyCallback: () => {
            this.fbUserLoaded = true
          }
        }
      }
    },
    computed: {
      pageStart () {
        return (this.currentPage - 1) * this.countOfPage
      },
      dataLoading () {
        if (this.fbDeviceLoaded && this.fbDeviceOnlineLoaded && this.fbUserLoaded) {
          /* re-asign data to proper key name, and reproduce the required computed data */
          const fbd = [...this.fbDevice]
          const fbdo = _.keys({...this.fbDeviceOnline})
          const fbu = {...this.fbUser}
          const ut = {...this.userType}
          const devicesGroupByUser = _.groupBy(fbd, 'ownerId')

          /* zero down amount of device type to avoid add up every loading */
          _.forEach(ut, (t, index) => {
            t.amount = 0
            t.onlineAmount = 0
            t.offlineAmount = 0
            t.noRecordAmount = 0
          })

          /* properly manipulate data to be an more useful dataset */
          const handledData = _.forEach(fbu, (user, key) => {
            // console.log(user)
            const userAccessLog = user.accessLog || null

            /* rename (to camel pattern) */
            user.lastIP = user.last_ip
            user.photo = user.photo_link || null
            user.sessionTime = user.session_time

            /* add up User's device data */
            const hasDevice = typeof devicesGroupByUser[user['.key']] !== 'undefined'
            if (hasDevice) {
              /* arrage device data into user */
              user.devices = _.transform(devicesGroupByUser[user['.key']], (result, device, index) => {
                const isOnline = _.indexOf(fbdo, device['.key']) !== -1
                result.push({
                  ...device,
                  isOnline,
                  type: this.getDeviceType(device.typeId),
                  mac: device['.key']
                })
              }, [])
            } else {
              user.devices = []
            }
            user.hasDevice = hasDevice

            /* assign user status and count up online users */
            if (userAccessLog === null) {
              user.status = {
                info: 'no record',
                class: 'glyphicon-warning-sign',
                connectType: 'virgin'
              }
            } else {
              const logArr = _.values(userAccessLog)
              const latestLog = _.maxBy(logArr, 'time')
              let {time, type} = latestLog
              user.status = {
                info: `${type ? 'online' : 'offline'} ${moment(time).toNow(true)}`,
                class: 'glyphicon-time',
                connectType: (type ? 'online' : 'offline')
              }
              /* get ip */
              user.ip = []
              const uniqIP = _.map(_.uniqBy(logArr, 'ip'), 'ip')
              _.forEach(uniqIP, (ip, index) => {
                const latestIpRecord = _.maxBy(_.filter(userAccessLog, ['ip', ip]), 'time')
                user.ip.push(latestIpRecord)
              })
              // user.ip = _.uniqBy(logArr, 'ip')
              user.accessLog = _.values(userAccessLog)
            }
          })
          // console.log(handledData)

          /* Filtering Data */
          let filteredData = []
          /* filter for device type */
          const userTypeFilters =
            /* transform data to arr then get value which is not null as filter */
            _.pull(
              _.values({...this.filterUserTypeValue}),
              null
            )
          if (userTypeFilters.length === 0) {
            /* no userTypeFilters then show all */
            filteredData = handledData
          } else if (_.indexOf(userTypeFilters, 'Installer') !== -1) {
            filteredData = _.filter(handledData, (user) => {
              return user.installer
            })
          } else {
            filteredData = _.filter(handledData, (user) => {
              return !user.installer
            })
          }

          /* filter for device status */
          const userStatusFilters =
            /* transform data to arr then get value which is not null as filter */
            _.pull(
              _.values({...this.filterUserStatusValue}),
              null
            )
          if (userStatusFilters.length > 0) {
            filteredData = _.filter(filteredData, (user) => {
              return _.indexOf(userStatusFilters, user.status.connectType) !== -1
            })
          }

          this.outputData = _.toArray(filteredData)
          // console.log(this.outputData)

          /* finish loading */
          return false
        } else {
          return true
        }
      },
      modalOutputData () {
        /* Sort data */
        const sortType = this.currentSortBy
        const AorDESC = this.currentSortInASC ? 'asc' : 'desc'
        const data = [...this.modalData]

        /* Set reproduced data */
        return _.orderBy(data, [sortType], [AorDESC])
      }
    },
    ready () {

    },
    methods: {
      filterChanged () {
        this.currentPage = 1
        this.currPaginationSec = 1
        // console.log(this.filterUserTypeValue)
      },
      async ip2Location (ipList) {
        /* Locate IP */
        for (let i = 0; i < ipList.length; i++) {
          const ip = ipList[i].ip
          await axios.get(`https://freegeoip.net/json/${ip}`)
          .then((res) => {
            // console.log(res.data)
            const { city, country_name: countryName, longitude, latitude } = res.data
            const { time } = ipList[i]
            ipList[i] = {
              ...ipList[i],
              time,
              date: moment(time).format('dddd, MMMM Do YYYY, h:mm:ss a'),
              city,
              name: countryName,
              lon: longitude,
              lat: latitude
            }
          })
        }
        const mapOptionLocationData = {
          type: 'mappoint',
          name: 'Cities',
          color: Highcharts.getOptions().colors[1],
          data: ipList
        }
        // console.log(mapOptionLocationData)
        this.mapOptions.series[1] = mapOptionLocationData
        this.ip2LocationLoaded = true
      },
      getDeviceType (typeID) {
        const deviceType = ['power', 'matrix', 'mixer', 'splitter', 'ip switch', 'dio', 'smart controller', 'ir']
        return _.toUpper(deviceType[typeID - 1])
      },
      showUserDevices (ownerID) {
        /* load all user handled data */
        const od = [...this.outputData]
        const targetData = _.find(od, {'.key': ownerID})
        // console.log(targetData)
        /* set default sort type */
        this.currentSortBy = 'isOnline'
        this.currentSortInASC = false
        this.modalTitle = targetData.name
        this.modalPurpose = 'userDeviceTable'
        this.modalData = targetData.devices
        this.modalStatus = true
      },
      showUserAccessLog (ownerID) {
        /* load all user handled data */
        const od = [...this.outputData]
        const targetData = _.find(od, {'.key': ownerID})
        // console.log(targetData)
        /* set default sort type */
        this.currentSortBy = 'time'
        this.currentSortInASC = false
        this.modalTitle = targetData.name
        this.modalPurpose = 'userAccessLogTable'
        this.modalData = targetData.accessLog
        this.modalStatus = true
      },
      showUserLocation (user) {
        const {name, ip} = user
        // console.log(ip)
        this.modalTitle = name
        this.modalPurpose = 'location'
        this.ip2LocationLoaded = false
        this.ip2Location(ip)
        this.modalSize.large = true
        this.modalStatus = true
      },
      sortBy (type) {
        /* same sort type then reverse*/
        if (this.currentSortBy === type) {
          this.currentSortCount += 1  /* add up when click on same sort type */
          this.currentSortInASC = !this.currentSortInASC /* reverse */
          /* third click should cancel */
          if (this.currentSortCount === 3) {
            this.currentSortCount = 0
            this.currentSortBy = null
            this.currentSortInASC = null
          }
        } else {
          this.currentSortCount = 1
          this.currentSortBy = type
          this.currentSortInASC = true
        }
      }
    }
  }
</script>

<style scoped lang="scss">
$owner: #4a90e2;
$firmware: #ff7f01;

.user_title {
  display: inline-block;
  font-weight: bold;
  font-size: 24px;
  margin: 10px 0;
}

.device_icon {
  width: 80px;
  height: 80px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;
  background-color: grey;
}

.svg_icon {
  fill: red;
}

.user_photo {
  width: 100px;
  height: 100px;
}

.filter_container {
  padding-left: 16px;
}

.filter_option {
  font-size: 14px;
  font-weight: 300;
  margin-left: 8px;
  position: relative;
}

.filter_option_icon {
  margin-left: 8px;
}

.sort_default {
  color: rgba(199, 199, 199, 0.5);
}

.square {
	width: 80px;
	height: 80px;
  background-color: grey;
  border: 1px solid  rgba(51,51,51,0.3);
  border-radius: 5px;
}

.tag_container {
  display: inline-block;
  margin-right: 14px;
  border-radius: 5px;
  &.owner {
    border: 1px solid $owner;
  }
  &.firmware {
    border: 1px solid $firmware;
  }
}

.tag {
  display: inline-block;
  height: 20px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  &:after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-right: 8px solid transparent;
  }
  &.owner {
    margin-right: 20px;
    background-color: $owner;
    &:before {
      content: "Owner";
      padding: 0 6px;
      color: #FFF;
      text-align: center;
    }
    &:after {
      border-top: 20px solid $owner;
    }
  }
  &.firmware {
    margin-right:14px;
    background-color: $firmware;
    &:before {
      content: "Firmware";
      padding: 0 6px;
      color: #FFF;
      text-align: center;
    }
    &:after {
      border-top: 20px solid $firmware;
    }
  }
}

.owner {
  color: $owner;
  left: -8px;
}

.firmware {
  color: $firmware;
  margin-right: 5px;
}

.time{
  .glyphicon{
    font-size: 12px;
    cursor: default;
    padding-right:5px;
  }
  span{
    font-size: 12px;
  }
}

.virgin {
  color: #F00;
}

.offline {
  color: #777;
}

.online {
  color: #00cc53;
}

.badge_container {
  position: absolute;
  left: 0;
}
.installer_badge {
  display: block;
  position: absolute;
  transform: rotateZ(-45deg);
  padding: 0 28px;
  top: 8px;
  left: -6px;
  // background-color: rgba(0, 0, 0, 0);
  color: #FFF;
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;
  border-bottom: 20px solid #ff7f01;
  &:after {
    position: absolute;
    right: 2px;
    content: "Installer";
    color: #FFF;
    font-weight: bold;
  }
}

.modal-body {
  max-height: 500px;
  overflow: auto;
}

.modal-footer {
  border-top: 0px;
}

.badge {
  &.offline {
    color: #FFF;
    background-color: #777;
  }
  &.online {
    color: #FFF;
    background-color: #00cc53;
  }
}
</style>



// WEBPACK FOOTER //
// Overview.vue?f1d0356e